import { Fragment } from "react";

import type { Crumb } from "./types";

export function MkBreadcrumb({ items, onSelect, className }: {
    items: Crumb[];
    onSelect?(id: string, item: Crumb): void;
    className?: string;
}) {
    return (
        <nav className={`mk-breadcrumb${className ? ` ${className}` : ""}`}>
            {items.map((item, index) => {
                const last = index === items.length - 1;
                const current = last && !item.home;
                return (
                    <Fragment key={index}>
                        <button className={`mk-crumb${current ? " mk-crumb-current" : ""}`}
                                disabled={current}
                                onClick={() => onSelect?.(item.id, item)}>
                            {item.icon && <i className={`fa ${item.icon}`} />}
                            <span>{item.label}</span>
                        </button>
                        {!last && <i className="fa fa-angle-right mk-crumb-sep" />}
                    </Fragment>
                );
            })}
        </nav>
    );
}
